// src/Components/TopSearchedTermsDetails.js
import React, { useState, useEffect } from "react";
import { getMostSearchedCount } from "../Service/apiService";
import "../assets/css/TopSearchedTerms.css";

const SKELETON_ROW_COUNT = 5; // Adjust as needed

export default function TopSearchedTermsDetails({ initialData = null }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      if (initialData !== null) {
        const sorted = Array.isArray(initialData)
          ? initialData.sort((a, b) => b.count - a.count)
          : [];
        setData(sorted);
        setLoading(false);
        return;
      }

      try {
        const result = await getMostSearchedCount();
        const sorted = Array.isArray(result)
          ? result.sort((a, b) => b.count - a.count)
          : [];
        setData(sorted);
        setError(null);
      } catch (err) {
        console.error("Failed to load top searched terms:", err);
        setError("Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [initialData]);

  if (error) {
    return (
      <div className="dashboard-detail-placeholder" style={{ color: "#d32f2f" }}>
        {error}
      </div>
    );
  }

  return (
    <div className="top-searches-table-wrapper">
      <h3>Top Searched Terms ({loading ? "—" : data.length})</h3>
      <div className="top-searches-table-container">
        <table className="top-searches-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Search Term</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              // Skeleton rows
              Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
                <tr key={i} className="skeleton-row">
                  <td>
                    <div className="skeleton skeleton-text"></div>
                  </td>
                  <td>
                    <div className="skeleton skeleton-text"></div>
                  </td>
                  <td>
                    <div className="skeleton skeleton-text"></div>
                  </td>
                </tr>
              ))
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.key || "—"}</td>
                  <td>{item.count?.toLocaleString() || "0"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="dashboard-detail-placeholder">
                  No data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}